/* eslint-disable react/no-unused-prop-types */
import type { ReactNode } from 'react';

export type RadioControlGroupValue = string | number;

export interface RadioControlGroupOptionProps {
    children?: ReactNode;
    error?: boolean | string;
    help?: ReactNode;
    label: string;
    value: RadioControlGroupValue;
}

// This is intentionally a stub; its purpose is to provide the TS contract for the
// props assumed to exist for the purpose of RadioControlGroup functionality
export const RadioControlGroupOption = (
    props: RadioControlGroupOptionProps
): ReactNode => props.children ?? null;
